import { render, staticRenderFns } from "./RequestFromUser.vue?vue&type=template&id=4e89ad16&"
import script from "@/scripts/users/requestFromUser.js?vue&type=script&lang=js&"
export * from "@/scripts/users/requestFromUser.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports